import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App'
import Vuex from 'vuex'
import router from './router/index'
import config from "./config.js"
import iView from 'iview';
import Vuetify from 'vuetify'
import VueQuillEditor from 'vue-quill-editor'
import $ from 'jquery'
import jQuery from 'jquery'
import { store } from './store/store'

//import axios from 'axios';
import 'iview/dist/styles/iview.css';
import '../static/css/global.css'
import '../font-awesome-4.7.0/css/font-awesome.min.css'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css'

// Quill Editor Css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// index.js or main.js
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// app.js
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import '../static/css/animate.css';

import InfiniteLoading from 'vue-infinite-loading';
// import VueHtml5Editor from 'vue-html5-editor'
import VueI18n from 'vue-i18n';

Vue.config.productionTip = false
//axios.defaults.withCredentials=true;
//Vue.prototype.$axios = axios;

Vue.use(Vuex);
Vue.use(iView);
Vue.use(VueResource);
Vue.use(VueQuillEditor)
Vue.use(Vuetify, {
    theme: store.getters.selectedTheme.theme,
    iconfont: 'fa',
    icons: {
        'cancel': 'fas fa-ban',
        'menu': 'fas fa-ellipsis-v'
    }
});

// Vue.use(VueHtml5Editor, {
//     showModuleName: false,
//     hiddenModules: ["info"],
//     image: {
//         sizeLimit: 1024 * 1024,
//         //发帖的image组件
//         upload: {
//         	url: null,
//         	headers: {'Authorization': 'Bearer '+ localStorage.getItem('token')},
//         	params: {},
//         	fieldName: 'upfile'
//     	},
//         // compress: {
//         //     width: 1600,
//         //     height: 1600,
//         //     quality: 80
//         // },
//         // 响应数据处理,最终返回图片链接
//         uploadHandler(response){
//         	if (response.resCode == 0) {
//         		alert(response)
//         	}
//         }
//     },
//     i18n: {
//         //i18n for custom module
//         "en-us": {
//             at: "at",
//             video: "video"
//         }
//     },
//     // 自定义要显示的模块，并控制顺序
//     // keep only the modules you want and customize the order.
//     // can be used with hiddenModules together
//     visibleModules: [
//         "text",
//         "color",
//         "font",
//         "align",
//         "list",
//         "link",
//         "unlink",
//         "tabulation",
//         "image",
//         "video",
//         "hr",
//         "eraser",
//         "undo",
//         "at",
//         "full-screen",
//     ],
//     //扩展模块
//     modules: [
//     	//自定义@模块
//         {
//             name: "at",
//             icon: "fa fa-at",
//             i18n: "at",
//             show: true,
//             init: function (editor) {
//                 //初始化函数
//             },
//             handler: function (editor) {
//                 // editor.execCommand("insertHTML", 'test')
//             },
//             destroyed: function (editor) {
//                 //销毁函数
//             }
//         },
//         {
//             name: "video",
//             icon: "fa fa-video",
//             i18n: "video",
//             show: true,
//             init: function (editor) {
//                 //初始化函数
//             },
//             handler: function (editor) {
//                 // editor.execCommand("insertHTML", 'test')
//             },
//             destroyed: function (editor) {
//                 //销毁函数
//             },
//         },
//     ]
// });
Vue.use(VueI18n);
// Vue.directive('title', {
//  inserted: function (el, binding) {
//  document.title = el.innerText
//  el.remove()
//  }
// })
// 设置浏览器标题
Vue.directive('title', {
	inserted: function (el, binding) {
		document.title = binding.value;
	}
});
// const store = new Vuex.Store({
// 	state:{
// 		user:{
// 			id:'',
// 			name:'',
// 			token:'',
// 			image:'',
// 			locale:''
// 		},
// 		loginModal: false,				//是否显示登录模态框
// 		// verificationSuccess: false,//登录时滑块是否验证成功
// 	},
// 	mutations: {
// 		setToken(state, payload){
//             if(payload.hasOwnProperty('name')){
//                 state.user.token = payload.name
//             }
//         },
//         setUserName(state, payload){
//             if(payload.hasOwnProperty('name')){
//                 state.user.name = payload.name
//             }
//         },
//         setUserId(state, payload){
//             if(payload.hasOwnProperty('name')){
//                 state.user.id = payload.name
//             }
//         },
//         setImage(state, payload){
//             if(payload.hasOwnProperty('name')){
//                 state.user.image = payload.name
//             }
//         },
//         setLocale(state, payload){
//             if(payload.hasOwnProperty('name')){
//                 state.user.locale = payload.name
//             }
//         },
//     },
// });

function getLanguage(){
	// 将选择的语言存在localStorage中 
	let locale = localStorage.getItem("SIP-locale");
	if (locale) {
		return locale;
	} else {
		return 'en-US'
	}
}

const language = getLanguage();

const i18n = new VueI18n({
	locale: language,
	messages:{
	    'de-DE':require('@/assets/lang/de-DE.json'),
	    'en-US':require('@/assets/lang/en-US.json'),
	    'ru-RU':require('@/assets/lang/ru-RU.json'),
	    'zh-CN':require('@/assets/lang/zh-CN.json')
	}
});

new Vue({
	el: '#app',
	i18n,
	router,
	store,
	template: '<App/>',
	components: { App, InfiniteLoading },
	created:function(){
		let tokenObject = localStorage.getItem("token");
		let usernameObject = localStorage.getItem("userName");
		let idObject = localStorage.getItem("id");
		let imageObject = localStorage.getItem("image");
		this.$store.commit('setToken', {name: tokenObject});
		this.$store.commit('setUserName', {name: usernameObject});
		this.$store.commit('setUserId', {name: idObject});
		this.$store.commit('setImage', {name: imageObject});
		if(usernameObject){
			this.$store.state.user.name = usernameObject;
		}
		if (idObject){
			this.$store.state.user.id = idObject;
		}
		if (imageObject){
			this.$store.state.user.image = imageObject;
		}
		if(tokenObject){
			this.$store.state.user.token = tokenObject;
			Vue.http.interceptors.push((request, next) => {
				// 接口每次请求会跨域携带cookie
				// request.credentials = true;
                // 前端迁移到 Cloudflare 则不需要跨域携带cookie
                request.credentials = false;
				// 请求headers携带参数
				request.headers.set('Authorization', 'Bearer '+ tokenObject);
				next((response) => {
					if (response.headers.get('isLogin') === 'false') {
						localStorage.removeItem("SIP-user");
			      		localStorage.removeItem("SIP-role");
			      		localStorage.removeItem("userName");
			      		localStorage.removeItem("id");
			      		localStorage.removeItem("token");
			      		localStorage.removeItem("image");
			      		localStorage.removeItem("invitationCode");
						this.$store.state.loginModal = true;
						this.$router.go();
					}
					if(response.data.resCode == 8000){
						 this.$router.push({name:'page500'});
					}
					return response;
				});
			});
		}else{
			Vue.http.interceptors.push((request, next) => {
				next((response) => {
					if (response.headers.get('isLogin') === 'false') {
						localStorage.removeItem("SIP-user");
			      		localStorage.removeItem("SIP-role");
			      		localStorage.removeItem("userName");
			      		localStorage.removeItem("id");
			      		localStorage.removeItem("token");
			      		localStorage.removeItem("image");
			      		localStorage.removeItem("invitationCode");
						this.$router.push({name: 'home'});
						this.$router.go();
					}
					if(response.data.resCode == 8000){
						 this.$router.push({name:'page500'});
					}
					return response;
				});
			});
		}
		
		// if (!sessionStorage.getItem("firstLoad")) {
		// 	if(usernameObject){
		// 		//如果用户登录，第一次加载项目时自动跳转到feed页面，其余不能跳转
		// 		//在sessionStorage中存入一个标志，代表是第一次加载
		// 		sessionStorage.setItem("firstLoad", usernameObject);
		// 		this.$router.push({name: 'feed', params: {username: '@' + usernameObject}});
		// 	}
		// }
    },
     methods:{
		 
	}
})


router.beforeEach((to, from, next) => {
	/**
	 * 参数说明：
     * to: Route: 即将要进入的目标 路由对象 
     * from: Route: 当前导航正要离开的路由 
     * next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数
	 */
	// 判断该路由是否需要登录权限
	if (to.meta.requireAuth) {
	  	//判断本地是否存在token
	    if(localStorage.getItem('token')){
	      next();
	    }else{
	    	this.$store.state.loginModal = true;
	      	next({
	         	path:'/'
	      	})
	      
	    }
	  }else {
	    	next();
	  }
	  //如果本地存在token则不允许直接跳转到登录页面
	  if(to.fullPath == "/login"){
	    if(localStorage.getItem('token')){
	      next({
	        path:from.fullPath
	      });
	    }else{
	      next();
	    }
	 }
});



// WEBPACK FOOTER //
// ./src/main.js